import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /permatitle-video/video/id/popup/
const path = ['web', process.env.FOLDER_LAYOUTS, 'audio', 'popup'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
